export const configRadarDhJP = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/JMA_OBS_RADAR_ECHINT_JP_5min/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_JP_ICDB_Radar",
      "url": "%expo_tile_gpv_url%/JMA_OBS_RADAR_ECHINT_JP_5min_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 3,
        "MaxZoom": 9,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120.5,
          "South": 21,
          "East": 149,
          "North": 46
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configRadarDhKR = {
  "timelist": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_KR_Radar/index.json",
    "retain": true,
    "cache_busting": true,
    "update_interval": 60
  },
  "data": {
    "Type": "TMS",
    "name": "WX_KR_Radar",
    "url": "%wrap_url%/WX_KR_Radar/%validtime%/%z%/%x%/%y%.png",
    "cache": true,
    "download_max": 32,
    "Grid": {
      "MinZoom": 3,
      "MaxZoom": 5,
      "BoundingBox": {
        "West": 121.02194444444402,
        "South": 30.62075326432318,
        "East": 133.26452268519893,
        "North": 41.21277777777782
      }
    }
  }
};

export const configRadarDhTW = {
  "timelist": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_TW_Radar/index.json",
    "retain": true,
    "cache_busting": true,
    "update_interval": 60
  },
  "data": {
    "Type": "TMS",
    "name": "WX_TW_Radar",
    "url": "%wrap_url%/WX_TW_Radar/%validtime%/%z%/%x%/%y%.png",
    "cache": true,
    "download_max": 32,
    "Grid": {
      "MinZoom": 3,
      "MaxZoom": 5,
      "BoundingBox": {
        "West": 117.30000000000003,
        "South": 19.69710540243941,
        "East": 124.79647158232984,
        "North": 27.20000000000001
      }
    }
  }
};

export const configRadarDhUSAK = {
  "timelist": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_US_AK_Radar/index.json",
    "retain": true,
    "cache_busting": true,
    "update_interval": 60
  },
  "data": {
    "Type": "TMS",
    "name": "WX_US_AK_Radar",
    "url": "%wrap_url%/WX_US_AK_Radar/%validtime%/%z%/%x%/%y%.png",
    "cache": true,
    "download_max": 32,
    "Grid": {
      "MinZoom": 3,
      "MaxZoom": 5,
      "BoundingBox": {
        "West": -170.00000000000003,
        "South": 50.00481070174565,
        "East": -129.99525761644381,
        "North": 70.00000000000003
      }
    }
  }
};

export const configRadarDhUSGU = {
  "timelist": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_US_GU_Radar/index.json",
    "retain": true,
    "cache_busting": true,
    "update_interval": 60
  },
  "data": {
    "Type": "TMS",
    "name": "WX_US_GU_Radar",
    "url": "%wrap_url%/WX_US_GU_Radar/%validtime%/%z%/%x%/%y%.png",
    "cache": true,
    "download_max": 32,
    "Grid": {
      "MinZoom": 3,
      "MaxZoom": 5,
      "BoundingBox": {
        "West": 142.00000000000003,
        "South": 10.30036347987301,
        "East": 147.29729999114161,
        "North": 16.00000000000000
      }
    }
  }
};

export const configRadarDhUSHI = {
  "timelist": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_US_HI_Radar/index.json",
    "retain": true,
    "cache_busting": true,
    "update_interval": 60
  },
  "data": {
    "Type": "TMS",
    "name": "WX_US_HI_Radar",
    "url": "%wrap_url%/WX_US_HI_Radar/%validtime%/%z%/%x%/%y%.png",
    "cache": true,
    "download_max": 32,
    "Grid": {
      "MinZoom": 3,
      "MaxZoom": 5,
      "BoundingBox": {
        "West": -162.00000000000003,
        "South": 15.99818554192968,
        "East": -151.99682505759694,
        "North": 24.00000000000001
      }
    }
  }
};

export const configRadarDhUSNA = {
  "timelist": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_US_NA_Radar/index.json",
    "retain": true,
    "cache_busting": true,
    "update_interval": 60
  },
  "data": {
    "Type": "TMS",
    "name": "WX_US_NA_Radar",
    "url": "%wrap_url%/WX_US_NA_Radar/%validtime%/%z%/%x%/%y%.png",
    "cache": true,
    "download_max": 32,
    "Grid": {
      "MinZoom": 3,
      "MaxZoom": 5,
      "BoundingBox": {
        "West": -130.00000000000003,
        "South": 19.99957312455711,
        "East": -60.00233323525850,
        "North": 52.00000000000002
      }
    }
  }
};

export const configRadarDhUSPR = {
  "timelist": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_US_PR_Radar/index.json",
    "retain": true,
    "cache_busting": true,
    "update_interval": 60
  },
  "data": {
    "Type": "TMS",
    "name": "WX_US_PR_Radar",
    "url": "%wrap_url%/WX_US_PR_Radar/%validtime%/%z%/%x%/%y%.png",
    "cache": true,
    "download_max": 32,
    "Grid": {
      "MinZoom": 3,
      "MaxZoom": 5,
      "BoundingBox": {
        "West": -70.00000000000000,
        "South": 16.00117465407314,
        "East": -62.00119161287849,
        "North": 21.00000000000000
      }
    }
  }
};

export const configRadarDhCA = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "_url": "%expo_tile_gpv_url%/CMS_OBS_RADAR/list",
      "url": "%expo_tile_gpv_url%/CMS_OBS_NAME_RADAR/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_CA_ICDB_Radar",
      "_url": "%expo_tile_gpv_url%/CMS_OBS_RADAR_%validtime%/%z%_%y%_%x%.png",
      "url": "%expo_tile_gpv_url%/CMS_OBS_NAME_RADAR_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 3,
        "MaxZoom": 7,
        "YCoordinate": -1,
        "_BoundingBox": {
          "West": -129,
          "South": 38,
          "East": -48,
          "North": 60
        },
        "BoundingBox": {
          "West": -169,
          "South": 16,
          "East": -49,
          "North": 68
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configRadarDhEU = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/EC_OBS_RADAR_ECHINT_EU/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_EU_Radar",
      "url": "%expo_tile_gpv_url%/EC_OBS_RADAR_ECHINT_EU_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 3,
        "MaxZoom": 6,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": -29,
          "East": 40,
          "North": 74,
          "South": 31
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configRadarDhAU = {
  "timelist": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_AU_Radar/index.json",
    "retain": true,
    "cache_busting": true,
    "update_interval": 60
  },
  "data": {
    "Type": "TMS",
    "name": "WX_AU_Radar",
    "url": "%wrap_url%/WX_AU_Radar/%validtime%/%z%/%x%/%y%.png",
    "cache": true,
    "download_max": 32,
    "Grid": {
      "MinZoom": 3,
      "MaxZoom": 5,
      "BoundingBox": {
        "West": 107.00000000000001,
        "South": -48.00603746596926,
        "East": 174.00697513195303,
        "North": -7.00000000000000
      }
    }
  }
};

const radarLayerConfig = {
  "Name": "XXX",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "rgb_palette",
        "palette": [[[255, 255, 255], [128, 128, 128, 25]]],
        "alternative_color": [128, 128, 128, 25]
      },
      "clear_coverage": {
        "type": "rgb_palette",
        "palette": [[[255, 255, 255], [0, 0, 0, 0]]],
        "alternative_color": [128, 128, 128, 128]
      }
    }
  }
};


const expoRadarLayerConfig = {
  "Name": "XXX",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "alternative_color": [128, 128, 128, 25],
        "palette": [
          [128, 128, 128, 25],
          [0, 0, 0, 1],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 0, 255, 150],
          [0, 0, 255, 150],
          [0, 0, 255, 150],
          [0, 0, 255, 150],
          [0, 0, 255, 150],
          [0, 0, 255, 150],
          [0, 0, 255, 150],
          [0, 0, 255, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [0, 255, 0, 150],
          [0, 255, 0, 150],
          [0, 255, 0, 150],
          [0, 255, 0, 150],
          [0, 255, 0, 150],
          [0, 255, 0, 150],
          [135, 255, 6, 150],
          [135, 255, 6, 150],
          [135, 255, 6, 150],
          [135, 255, 6, 150],
          [255, 255, 0, 150],
          [255, 255, 0, 150],
          [255, 255, 0, 150],
          [255, 255, 0, 150],
          [255, 255, 0, 150],
          [255, 255, 0, 150],
          [255, 255, 0, 150],
          [255, 255, 0, 150],
          [255, 191, 0, 150],
          [255, 191, 0, 150],
          [255, 191, 0, 150],
          [255, 191, 0, 150],
          [255, 191, 0, 150],
          [255, 191, 0, 150],
          [255, 191, 0, 150],
          [255, 191, 0, 150],
          [255, 165, 0, 150],
          [255, 165, 0, 150],
          [255, 165, 0, 150],
          [255, 165, 0, 150],
          [255, 165, 0, 150],
          [255, 165, 0, 150],
          [255, 165, 0, 150],
          [255, 165, 0, 150],
          [255, 140, 0, 150],
          [255, 140, 0, 150],
          [255, 140, 0, 150],
          [255, 140, 0, 150],
          [255, 140, 0, 150],
          [255, 140, 0, 150],
          [255, 140, 0, 150],
          [255, 140, 0, 150],
          [255, 21, 6, 150],
          [255, 21, 6, 150],
          [255, 21, 6, 150],
          [255, 21, 6, 150],
          [255, 21, 6, 150],
          [255, 21, 6, 150],
          [255, 21, 6, 150],
          [255, 21, 6, 150],
          [255, 0, 0, 150],
          [255, 0, 0, 150],
          [255, 0, 0, 150],
          [255, 0, 0, 150],
          [255, 0, 0, 150],
          [255, 0, 0, 150],
          [255, 0, 0, 150],
          [255, 0, 0, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [100, 100, 100, 30]
        ]
      },
      "clear_coverage": {
        "type": "grayscale_palette",
        "alternative_color": [0, 0, 0, 0],
        "palette": [
          [0, 0, 0, 0],
          [0, 0, 0, 1],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 255, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 144, 255, 150],
          [0, 0, 255, 150],
          [0, 0, 255, 150],
          [0, 0, 255, 150],
          [0, 0, 255, 150],
          [0, 0, 255, 150],
          [0, 0, 255, 150],
          [0, 0, 255, 150],
          [0, 0, 255, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [6, 207, 34, 150],
          [0, 255, 0, 150],
          [0, 255, 0, 150],
          [0, 255, 0, 150],
          [0, 255, 0, 150],
          [0, 255, 0, 150],
          [0, 255, 0, 150],
          [135, 255, 6, 150],
          [135, 255, 6, 150],
          [135, 255, 6, 150],
          [135, 255, 6, 150],
          [255, 255, 0, 150],
          [255, 255, 0, 150],
          [255, 255, 0, 150],
          [255, 255, 0, 150],
          [255, 255, 0, 150],
          [255, 255, 0, 150],
          [255, 255, 0, 150],
          [255, 255, 0, 150],
          [255, 191, 0, 150],
          [255, 191, 0, 150],
          [255, 191, 0, 150],
          [255, 191, 0, 150],
          [255, 191, 0, 150],
          [255, 191, 0, 150],
          [255, 191, 0, 150],
          [255, 191, 0, 150],
          [255, 165, 0, 150],
          [255, 165, 0, 150],
          [255, 165, 0, 150],
          [255, 165, 0, 150],
          [255, 165, 0, 150],
          [255, 165, 0, 150],
          [255, 165, 0, 150],
          [255, 165, 0, 150],
          [255, 140, 0, 150],
          [255, 140, 0, 150],
          [255, 140, 0, 150],
          [255, 140, 0, 150],
          [255, 140, 0, 150],
          [255, 140, 0, 150],
          [255, 140, 0, 150],
          [255, 140, 0, 150],
          [255, 21, 6, 150],
          [255, 21, 6, 150],
          [255, 21, 6, 150],
          [255, 21, 6, 150],
          [255, 21, 6, 150],
          [255, 21, 6, 150],
          [255, 21, 6, 150],
          [255, 21, 6, 150],
          [255, 0, 0, 150],
          [255, 0, 0, 150],
          [255, 0, 0, 150],
          [255, 0, 0, 150],
          [255, 0, 0, 150],
          [255, 0, 0, 150],
          [255, 0, 0, 150],
          [255, 0, 0, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [244, 0, 161, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [255, 0, 255, 150],
          [100, 100, 100, 30]
        ]
      }
    }
  }
};

export const configRadarLayerJP = {...expoRadarLayerConfig, Name: 'RadarJP'};
export const configRadarLayerCA = {...expoRadarLayerConfig, Name: 'RadarCA'};
export const configRadarLayerEU = {...expoRadarLayerConfig, Name: 'RadarEU'};
export const configRadarLayerKR = {...radarLayerConfig, Name: 'RadarKR'};
export const configRadarLayerTW = {...radarLayerConfig, Name: 'RadarTW'};
export const configRadarLayerUSAK = {...radarLayerConfig, Name: 'RadarUSAK'};
export const configRadarLayerUSGU = {...radarLayerConfig, Name: 'RadarUSGU'};
export const configRadarLayerUSHI = {...radarLayerConfig, Name: 'RadarUSHI'};
export const configRadarLayerUSNA = {...radarLayerConfig, Name: 'RadarUSNA'};
export const configRadarLayerUSPR = {...radarLayerConfig, Name: 'RadarUSPR'};
export const configRadarLayerAU = {...radarLayerConfig, Name: 'RadarAU'};